'use client'

import { Navbar } from '@/components/shared/layout/navbar'
import { isMobileQuery } from '@/components/ui/responsive'
import { useBetterMediaQuery } from '@/lib/hooks'
import { GlobalNavStoryblok } from '@/lib/types/component-types-sb'
import { MobileNav } from './mobile-nav'

export function Nav({ content }: { content: GlobalNavStoryblok }) {
  const isMobile = useBetterMediaQuery(isMobileQuery)

  return isMobile ? <MobileNav content={content} /> : <Navbar content={content} />
}
